import React from "react";

const CITIES = [
  "Los Angeles", "Long Beach", "Cerritos", "Anaheim", "Costa Mesa",
  "Lakewood", "Downey", "San Gabriel", "Whittier", "Cypress",
  "Irvine", "Santa Ana", "Huntington Beach", "Pasadena", "Orange County",
];

export const CityMarquee = () => {
  const row = [...CITIES, ...CITIES];
  return (
    <div className="bg-[#254369] py-4 overflow-hidden marquee" data-testid="city-marquee">
      <div className="marquee-track">
        {row.map((c, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-heading font-semibold text-white/90 text-sm tracking-wide px-6">
              {c}
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#C9A961]" />
          </span>
        ))}
      </div>
    </div>
  );
};
